import { create } from 'zustand';

export const useSettingsStore = create((set) => ({
  theme: 'light',
  setTheme: (theme) => set({ theme }),

  darkToggle: false,
  setDarkToggle: (darkToggle) => set({ darkToggle }),

  hasImage: false,
  setHasImage: (hasImage) => set({ hasImage }),
}));
